import { render, staticRenderFns } from "./ImageMark.vue?vue&type=template&id=9b4c6840&"
import script from "./ImageMark.vue?vue&type=script&lang=ts&"
export * from "./ImageMark.vue?vue&type=script&lang=ts&"
import style0 from "./ImageMark.vue?vue&type=style&index=0&id=9b4c6840&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports